import { Box, Link, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Check } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/benefits/pages/EmployeesPage/ActivateBenefitsModal/types'

export const BenefitsComplianceStep = ({}: WizardStepRenderParams<WizardData>) => {
  const { company } = useCurrentSession()

  const bulletPoints = [
    i18n.t(
      'benefits.tabs.employees.activation_results.modal.accept_compliance.requirements.eligibility'
    ),
    i18n.t(
      'benefits.tabs.employees.activation_results.modal.accept_compliance.requirements.responsibility'
    ),
    i18n.t(
      'benefits.tabs.employees.activation_results.modal.accept_compliance.requirements.platform_role'
    ),
  ]

  useEffect(() => {
    track(trackingEvents.benefits.userLandsInBenefitsActivationCompliance, {
      companyId: company.id,
    })
  }, [company.id])

  return (
    <Box flexDirection="row" position="relative" justifyContent="center">
      <Box flexDirection="column" paddingBottom="s20">
        <Box paddingBottom="s24">
          <Text.Normal weight="semibold" color="grey1000" size="400">
            {i18n.t(
              'benefits.tabs.employees.activation_results.modal.accept_compliance.step_title'
            )}
          </Text.Normal>
        </Box>

        <Box paddingBottom="s12">
          <Text.Normal weight="normal" color="grey800" size="300">
            {i18n.t(
              'benefits.tabs.employees.activation_results.modal.accept_compliance.introduction_text'
            )}{' '}
            <Text.Normal weight="semibold" color="grey800" size="300">
              {i18n.t(
                'benefits.tabs.employees.activation_results.modal.accept_compliance.introduction_emphasis'
              )}
            </Text.Normal>
          </Text.Normal>
        </Box>

        <Box justifyContent="flexStart" alignItems="flexStart">
          {bulletPoints.map((bulletPoint, index) => (
            <Box
              key={index}
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
              paddingBottom="s8"
            >
              <Box paddingRight="s12">
                <F0Icon icon={Check} size="lg" className="text-f1-icon-positive" />
              </Box>

              <Text.Normal weight="normal" color="grey800" size="300">
                {bulletPoint}
              </Text.Normal>
            </Box>
          ))}
        </Box>

        <Box paddingTop="s2">
          <Text.Normal weight="normal" color="grey800" size="300">
            {i18n.t(
              'benefits.tabs.employees.activation_results.modal.accept_compliance.terms.prefix'
            )}{' '}
            <Link.Href
              external
              target="_blank"
              type="solid"
              href="https://factorialhr.com/terms-of-use"
            >
              {i18n.t(
                'benefits.tabs.employees.activation_results.modal.accept_compliance.terms.link_text'
              )}
            </Link.Href>{' '}
            {i18n.t(
              'benefits.tabs.employees.activation_results.modal.accept_compliance.terms.suffix'
            )}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}
